export const APP_DETAILS_REQUEST = 'APP_DETAILS_REQUEST';
export const APP_DETAILS_SUCCESS = 'APP_DETAILS_SUCCESS';
export const APP_DETAILS_FAILURE = 'APP_DETAILS_FAILURE';

export const APP_RECOMMEND_REQUEST = 'APP_RECOMMEND_REQUEST';
export const APP_RECOMMEND_SUCCESS = 'APP_RECOMMEND_SUCCESS';
export const APP_RECOMMEND_FAILURE = 'APP_RECOMMEND_FAILURE';

export const APP_GROUP_REQUEST = 'APP_GROUP_REQUEST';
export const APP_GROUP_SUCCESS = 'APP_GROUP_SUCCESS';

export const APP_DETAILS_GIFT_REQUEST = 'APP_DETAILS_GIFT_REQUEST';
export const APP_DETAILS_GIFT_SUCCESS = 'APP_DETAILS_GIFT_SUCCESS';

export const APP_DETAILS_GIFT_RECEIVE_REQUEST = 'APP_DETAILS_GIFT_RECEIVE_REQUEST';
export const APP_DETAILS_GIFT_RECEIVE_SUCCESS = 'APP_DETAILS_GIFT_RECEIVE_SUCCESS';

export const APP_FORUM_RELATED_REQUEST = 'APP_FORUM_RELATED_REQUEST';
export const APP_FORUM_RELATED_SUCCESS = 'APP_FORUM_RELATED_SUCCESS';
